import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  caution: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    background: "var(--app-surface)",
    alignSelf: "flex-end",
    width: "100%",
    gap: "10px 15px",
    padding: "12px 20px",
    "& p": {
      margin: "0",
    },
  },
  dFlex: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "5px",
    fontWeight: "500",
    "& p": {
      color: "var(--app-text-muted)",
      fontFamily: "Inter",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "normal",
      whiteSpace: "nowrap",
      fontSize: "14px",
      "@media (max-width: 1600px)": {
        fontSize: "12px",
      },
      "@media (max-width: 1440px)": {
        fontSize: "11px",
      },
    },
  },
  greenBox: {
    width: "15px",
    height: "15px",
    background: "#4fa80d",
  },
  redBox: {
    width: "15px",
    height: "15px",
    background: "#eb7a74",
  },
  blueBox: {
    width: "15px",
    height: "15px",
    background: "#c7daf5",
  },
  grayBox: {
    width: "15px",
    height: "15px",
    background: "#979797",
  },
  yellowBox: {
    width: "15px",
    height: "15px",
    background: "#feff80",
  },
  blackBox: {
    width: "15px",
    height: "15px",
    background: "#000",
  },
  purpleBox: {
    width: "15px",
    height: "15px",
    background: "#a03399",
  },

    brownBox: {
    width: "15px",
    height: "15px",
    background: "#8B4513",
  },
  divider: {
    width: "1px",
    backgroundColor: "var(--app-border)",
    height: "20px",
  },
}));

export default useStyles;
